function Matches (value, attrValue) {
    if (!attrValue) {
        return true;
    }
    return value === attrValue;
}

export default Matches;
